import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../hooks/useAuth';
import { isAdminEmail } from '../../utils/adminWhitelist';
import AdminLogin from './AdminLogin';

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f8fb 0%, #ffffff 100%);
`;

const UnauthorizedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f8fb 0%, #ffffff 100%);
  padding: 2rem;
  text-align: center;
`;

const UnauthorizedTitle = styled.h1`
  font-size: 2rem;
  color: var(--secondary-color);
  margin-bottom: 1rem;
`;

const UnauthorizedText = styled.p`
  font-size: 1.125rem;
  color: var(--gray-600);
  margin-bottom: 2rem;
`;

const AdminRoute = ({ children }) => {
  const { session, loading, initialized } = useAuth();

  // Show loading state while auth is initializing
  if (!initialized || loading) {
    return (
      <LoadingContainer>
        <div style={{ fontSize: '1.25rem', color: 'var(--secondary-color)' }}>
          Loading...
        </div>
      </LoadingContainer>
    );
  }

  // If no session, show login page
  if (!session || !session.user) {
    return <AdminLogin />;
  }

  // Get user email from session
  const userEmail = session.user.email;

  // Check if user email is in admin whitelist
  if (!isAdminEmail(userEmail)) {
    return (
      <UnauthorizedContainer>
        <UnauthorizedTitle>Access Denied</UnauthorizedTitle>
        <UnauthorizedText>
          You don't have permission to access the admin dashboard.
          <br />
          <br />
          Your email ({userEmail}) is not in the admin whitelist.
        </UnauthorizedText>
      </UnauthorizedContainer>
    );
  }

  // User is authenticated and authorized
  return <>{children}</>;
};

export default AdminRoute;
